export const getAuthData = () => {
  return {
    token: localStorage.getItem('token'),
    role: localStorage.getItem('role'),
    empId: localStorage.getItem('emp_id'),
    firstName: localStorage.getItem('first_name') || 'User'
  };
};

export const clearAuth = () => {
  localStorage.clear();
};

export const isAuthenticated = () => {
  const { token, role, empId } = getAuthData();
  return !!(token && role && empId);
};

export const getProfilePicUrl = (baseUrl) => {
  const { empId, token } = getAuthData();
  if (!empId) return '';
  const id = empId.trim().toUpperCase();
  
  // Attach the JWT token directly to the URL so standard <img> tags can authenticate
  let url = `${baseUrl}/employees/${id}/profile-picture?t=${Date.now()}`;
  if (token) {
    url += `&token=${token}`;
  }
  return url;
};